import React from 'react';
import { getBannerComponent } from './banners';
import styles from './styles/HeroSlide.module.css';

/**
 * Componente que renderiza un slide basado en su tipo
 * @param {Object} banner - Configuración del banner
 */
const HeroSlide = ({ banner }) => {
  if (!banner) {
    return <div className={styles.emptySlide}>No hay contenido disponible</div>;
  }

  const BannerComponent = getBannerComponent(banner.type);

  if (!BannerComponent) {
    console.warn(`Banner type "${banner.type}" no está registrado`);
    return (
      <div className={styles.invalidBanner}>
        <p>Tipo de banner no soportado: {banner.type}</p>
      </div>
    );
  }

  return (
    <div className={styles.heroSlide}>
      <BannerComponent {...banner} />
    </div>
  );
};

export default HeroSlide;
